import ContentfulRichText from './ContentfulRichText';

export { default as ContentfulRichTextTheme } from './ContentfulRichText.style';
export default ContentfulRichText;
